module.exports = __webpack_public_path__ + "img/analytics_mobile_5775330.png";